import { Box, IconButton, SwipeableDrawer, Tooltip } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import * as OnboardEntity from '../../../Entities/OnBoardingContainerTypes'
import ProofAndPenalties from './CommonUI/ProofAndPenalties'
import SaveCancelButton from 'src/Common/ui/SaveCancelButton'
import { useForm } from 'react-hook-form'
import FormsDrawer from './FormsDrawer'
import Remarks from './CommonUI/Remarks'
import ThresholdDrawer from './ThresholdDrawer'
import DatePickerInput from 'src/Common/ui/DatePickerInput'
import { t } from 'i18next'
import { useCompStore } from 'src/Components/Governance/Store/ComplianceStore'
import PropTypes from 'prop-types'
import * as MeetingTypes from '../../../Entities/MeetingTypes'
import MultiFileSelect from 'src/Common/ui/MultiSelectFile'
import { IoIosCloseCircleOutline } from 'react-icons/io'
import Input from 'src/Common/ui/input'
import { browserDateConvert } from 'src/Entities/CommonEntities'
import { cn } from 'src/lib/utils'

function ComplianceDrawer({ wholeData, apiCall, surveyValidate, viewCompById, setEditState, editData, setEditData, editState, drawType }) {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)
    const { createUserCompliance, putModifiedDueDate } = useCompStore()
    const { register, handleSubmit, setValue, trigger, formState: { errors, isSubmitting, isLoading }, control, reset } = useForm({ mode: 'onChange' })
    const [formObject, setFormObject] = useState({
        byWhen: null,
        fineAmount: '',
        evidence: [],
        evidenceLink: '',
        id: null
    })

    const [remark, setRemark] = useState('')
    // eslint-disable-next-line no-unused-vars
    const [dueDate, setDueDate] = useState('')
    const [thresholdObject, setThresholdObject] = useState({
        investAmount: 0,
        investOn: null,
        marketAmount: 0,
        marketOn: null
    })
    const userId = localStorage.getItem('userId')
    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event &&
            event.type === OnboardEntity.KEYDOWN &&
            (event.key === OnboardEntity.TAB || event.key === OnboardEntity.SHIFT)
        ) {
            return
        }
        setEditState({ ...editState, [anchor]: open })
    }
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth)
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])
    useEffect(() => {
        setRemark(editData?.remarks)
    }, [editState])
    const submitValidation = () => {
        if (drawType === 'dueDateEdit') {
            handleEditDueDate()
        } else {
            handleSave()
        }
    }
    const handleSave = () => {
        let finalData = wholeData

        if (drawType === 'threshold') {
            finalData = {
                ...finalData,
                thresholdLimitResponses: finalData.thresholdLimits.map((item) => {
                    if (item.id === editData.id) {
                        item.thresholdLimitResponses[0].investedAmount = thresholdObject.investAmount
                        item.thresholdLimitResponses[0].thresholdId = editData.id
                        item.thresholdLimitResponses[0].investedAsOn = new Date(thresholdObject.investOn).toISOString()
                        item.thresholdLimitResponses[0].marketValueAmount = thresholdObject.marketAmount
                        item.thresholdLimitResponses[0].marketValueAsOn = new Date(thresholdObject.marketOn).toISOString()
                        item.thresholdLimitResponses[0].remark = remark
                    }
                    return item
                })
            }
        } else if (drawType === 'form') {
            finalData = {
                ...finalData,
                formResponses: finalData.forms.map((item) => {
                    if (item.id === editData.id) {
                        if (item?.formResponses?.length > 0) {
                            item.formResponses[0].byWhen = formObject?.byWhen
                            item.formResponses[0].formId = editData.id
                            item.formResponses[0].Id = formObject?.id
                            item.formResponses[0].fineAmount = formObject?.fineAmount
                            item.formResponses[0].attachment = formObject?.evidence
                            item.formResponses[0].remark = remark
                            item.formResponses[0].evidenceLink = formObject?.evidenceLink
                        }
                    }
                    return item
                })
            }
        }
        const finalWholeData = {
            id: finalData.regulationId,
            complianceId: finalData.id,
            orgId: finalData.organizationId,
            loginId: userId,
            action: finalData.complainceTimeline[0]?.action,
            timeline: finalData.complainceTimeline[0]?.timeline,
            period: finalData.complainceTimeline[0]?.period,
            frequency: finalData.frequency,
            dueBy: finalData.dueBy,
            cutOff: finalData.cutOff,
            dueFor: finalData.dueFor,
            internalCutoff: 0,
            binaryAnswers: finalData?.binaryQuestions?.map((item) => {
                if (item.answer) {
                    const binItem = {
                        questionUID: item.questionUID
                    }
                    if (item.answer === '1' || item.answer === '2') {
                        binItem.quesId = null
                        binItem.answer = +item.answer
                    } else {
                        binItem.quesId = item.answer
                        binItem.answer = 0
                    }
                    return binItem
                }
                return null
            }).filter(ele => ele !== null),
            formResponses: finalData.forms.map((item) => {
                Object.keys(item.formResponses[0]).forEach((ele) => {
                    if (!item.formResponses[0][ele]) {
                        delete item.formResponses[0][ele]
                    }
                })
                return item.formResponses[0]
            }).filter(ele => ele !== null),
            thresholdLimitResponses: finalData.thresholdLimits.map((item) => {
                const verify = Object.keys(item.thresholdLimitResponses[0]).some((ele) => {
                    return item.thresholdLimitResponses[0][ele]
                })
                if (verify) {
                    return item.thresholdLimitResponses[0]
                }
                return null
            }).filter(ele => ele !== null),
            checkListResponses: finalData.checkLIst.map(item => {
                return {
                    checkListId: item?.id,
                    response: item?.response,
                    completedDate: item?.completedDate
                }
            })
        }
        createUserCompliance(finalWholeData).then(() => {
            setEditState({ right: false })
            clearFunction()
            viewCompById()
        })
        surveyValidate(finalData, 'draw')
    }
    function dateToUtcMidnightISO(date = new Date()) {
        const d = new Date(date); // clone
        d.setUTCHours(0, 0, 0, 0);
        return d.toISOString();
    }
    const handleEditDueDate = () => {
        setEditState({ right: false })
        const tempMemRemark = remark
        dueDate.setDate(dueDate.getDate() + 1)
        const finalData = {
            id: wholeData.regulationId,
            compId: wholeData.id,
            existingDueDate: dateToUtcMidnightISO(wholeData.dueBy),
            // modifiedDueBy: new Date(dueDate).toISOString(),
            modifiedDueBy: typeof dueDate === 'object' ? dateToUtcMidnightISO(dueDate) : dueDate,
            fileRequest: editData?.evidence,
            dueBy: dateToUtcMidnightISO(wholeData.dueBy),
            dueFor: dateToUtcMidnightISO(wholeData.dueFor),
            cutOff: dateToUtcMidnightISO(wholeData.cutOff),
            remarks: tempMemRemark,
            orgId: wholeData.organizationId,
            loginId: userId
        }

        putModifiedDueDate(finalData).then(() => {
            setEditData(null)
            apiCall()
            reset()
        }).catch((err) => {
            console.log(err)
        })
    }
    const hasSetValues = useRef(false)
    useEffect(() => {
        if (editState.right) {
            if (drawType === 'form') {
                setFormObject(prevState => ({
                    ...prevState,
                    byWhen: editData?.formResponses[0]?.byWhen,
                    fineAmount: editData?.formResponses[0]?.fineAmount,
                    evidence: editData?.formResponses[0]?.attachment,
                    evidenceLink: editData?.formResponses[0]?.evidenceLink,
                    id: editData?.formResponses[0]?.id
                }))
                // if (!hasSetValues.current) {
                setValue('byWhen', editData?.formResponses[0]?.byWhen)
                setValue('Evidence', editData?.formResponses[0]?.attachment)
                setValue('fineAmount', editData?.formResponses[0]?.fineAmount)
                // }

                setRemark(editData?.formResponses[0]?.remark || '')
            } else if (drawType === 'threshold') {
                setThresholdObject(prevState => ({
                    ...prevState,
                    investAmount: editData?.thresholdLimitResponses[0]?.investedAmount,
                    investOn: editData?.thresholdLimitResponses[0]?.investedAsOn,
                    marketAmount: editData?.thresholdLimitResponses[0]?.marketValueAmount,
                    marketOn: editData?.thresholdLimitResponses[0]?.marketValueAsOn

                }))
                setRemark(editData?.thresholdLimitResponses[0]?.remark || '')
            } else if (drawType === 'dueDateEdit' && editState.right) {
                if (!dueDate && (editData?.dueBy || wholeData?.dueBy)) {
                    setDueDate(wholeData?.modifiedDue ? wholeData?.modifiedDue : wholeData?.dueBy)
                }
                if (!remark && editData?.remarks) {
                    setRemark(editData?.remarks)
                }
                if (!hasSetValues.current) {
                    setValue('remarks-question', editData?.remarks)
                    setValue('SupportingDocuments', editData?.evidence)
                }
            }
            if (!hasSetValues.current) {
                hasSetValues.current = true
            }
        }
    }, [editState, editData])
    const editName = (item) => {
        switch (drawType) {
            case 'form':
                return item?.documentName
            case 'threshold':
                return item?.type

            default:
                return 'Hard Target'
        }
    }
    const penAndFine = (item) => {
        switch (drawType) {
            case 'form':
                return [item?.penaltiesandFine, item?.damageToReputation]
            case 'threshold':
                return [item?.penaltyandFine, item?.damageToReputation]

            default:
                break
        }
    }
    const handleDateChange = (value) => {
        setDueDate(value)
    }
    const handleCancel = () => {
        clearFunction()
        hasSetValues.current = false
        setDueDate(editData?.dueBy)
        setRemark(editData?.remarks)
        setEditData(null)
        setTimeout(() => {
            setEditState({ right: false })
        }, 100)
    }
    const handleImageChange = (value, name) => {
        if (name === MeetingTypes.SUPPORTING_DOCUMENTS) {
            const newFiles = []
            value?.forEach((file) => {
                if (file) {
                    const reader = new FileReader()
                    reader.onloadend = () => {
                        const fileObject = {
                            file: reader.result.split(',')[1],
                            contentType: file.type,
                            fileName: file.name
                        }

                        newFiles.push(fileObject)

                        if (newFiles.length === value.length) {
                            setEditData((prevData) => ({
                                ...prevData,
                                evidence: [...newFiles]
                            }))
                            setValue(name, newFiles, { shouldValidate: true })
                        }
                    }
                    reader.readAsDataURL(file)
                }
            })
        }
    }
    const handleEvidenceChange = (value, name) => {
        const newFiles = []

        value?.forEach((file) => {
            if (file) {
                const reader = new FileReader()
                reader.onloadend = () => {
                    const fileObject = {
                        file: reader.result.split(',')[1],
                        contentType: file.type,
                        fileName: file.name
                    }

                    newFiles.push(fileObject)

                    if (newFiles.length === value.length) {
                        setFormObject({
                            ...formObject,
                            evidence: [...newFiles],
                            evidenceLink: ''
                        })
                        setValue(name, newFiles, { shouldValidate: true })
                        setTimeout(() => {
                            setValue('evidenceLink', '')
                            trigger()
                        }, 500)
                    }
                }
                reader.readAsDataURL(file)
            }
        })
        trigger()
        if (value.length === 0) {
            setFormObject({
                ...formObject,
                evidence: []
            })
            setValue(name, newFiles, { shouldValidate: true })
        }
    }
    const clearFunction = () => {
        setFormObject({
            byWhen: null,
            fineAmount: '',
            evidence: [],
            id: null
        })
        setThresholdObject({
            investAmount: 0,
            investOn: null,
            marketAmount: 0,
            marketOn: null
        })

        setEditData(null)

        reset()
    }
    const handleInput = (e) => {
        setFormObject(prevState => ({
            ...prevState,
            evidenceLink: e.target.value
        }))
    }
    return (
        <div>
            <SwipeableDrawer
                PaperProps={{ sx: { width: windowWidth / 3, overflowX: 'hidden', minWidth: '429px', zIndex: 0 } }}
                className='m-2 z-auto'
                anchor={'right'}
                open={editState?.right}
                onClose={toggleDrawer('right', false)}
                onOpen={toggleDrawer('right', true)}
            >
                <div className="flex justify-between items-center pr-4 border-b-2 border-[hsl(var(--primary-table-head))]">
                    <p className="text-primary text-h2 p-4" style={{ color: 'hsl(var(--primary))' }}>Edit {'(' + editName(editData) + ')'}</p>
                    <Tooltip title="Close" placement="left" arrow componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                        <IconButton onClick={() => handleCancel()} aria-label="close" disabled={isSubmitting || isLoading}>
                            <IoIosCloseCircleOutline className='text-[hsl(var(--primary))]' />
                        </IconButton>
                    </Tooltip>
                </div>
                <div className='p-4 flex flex-col gap-3'>
                    {drawType === 'dueDateEdit' &&
                        <Box display='grid' gridTemplateColumns={'repeat(2, 1fr)'} gap={4}>

                            <Box gridColumn='span 1'>
                                <DatePickerInput
                                    control={control}
                                    required
                                    // rules={{ required: t('From date is required') }}
                                    name='due by'
                                    label={t('Hard Target')}
                                    // register={register}
                                    type="text"
                                    value={dueDate}
                                    onValueChange={handleDateChange}
                                // maxDate={fromMaxDate}
                                />
                            </Box>

                        </Box>}
                    {drawType === 'form' && <FormsDrawer register={register} errors={errors} editState={editState} name={editName(editData)} drawType={drawType} formObject={formObject} setFormObject={setFormObject} control={control} />}
                    {drawType === 'threshold' && <ThresholdDrawer drawType={drawType} name={editName(editData)} thresholdObject={thresholdObject} setThresholdObject={setThresholdObject} data={editData} control={control} />}
                    <Remarks remark={remark} required={drawType === 'dueDateEdit'} errors={errors} setRemark={setRemark} control={control} />
                    {
                        drawType === 'dueDateEdit' && <div>
                            <MultiFileSelect
                                name="SupportingDocuments"
                                label="Supporting Documents"
                                required={true}
                                register={register}
                                errors={errors}
                                onValueChange={handleImageChange}
                                defaultValue={editData?.evidence}
                                value={editData?.evidence}
                                className='!h-[100%]'
                            />

                        </div>
                    }
                    {drawType === 'form' &&
                        <>
                            <MultiFileSelect
                                name="Evidence"
                                label="Evidence"
                                className={cn(!formObject?.evidenceLink || formObject?.evidenceLink?.length === 0 ? '' : 'pointer-events-none opacity-50')}
                                required={!formObject?.evidenceLink || formObject?.evidenceLink?.length === 0}
                                register={register}
                                errors={errors}
                                onValueChange={handleEvidenceChange}
                                defaultValue={formObject.evidence}
                                value={formObject.evidence}
                            />
                            <div className='my-4 w-full'>
                                <Input
                                    className={cn(!formObject?.evidence || formObject?.evidence?.length === 0 ? '' : 'pointer-events-none opacity-50', '!w-full')}
                                    control={control}
                                    name='evidenceLink'
                                    label={'Evidence Link'}
                                    placeholder="Enter Evidence Link"
                                    type="text"
                                    rules={{
                                        validate: (value) => {
                                            const urlRegex = /\b((?:https?:\/\/|www\d{0,3}[.])?[a-z0-9.-]+[.](?:[a-z]{2,13})(?:[:]\d+)?(?:[/?#]\S*)?)\b/i
                                            function containsURL(text) {
                                                return urlRegex.test(text)
                                            }
                                            if (value?.length > 0 && !containsURL(value)) {
                                                return 'Please enter a valid URL'
                                            }
                                            if (value.length === 0 && formObject?.evidence?.length === 0) {
                                                return 'This field is required'
                                            } else {
                                                return true
                                            }
                                        }
                                    }}

                                    required={!formObject?.evidence || formObject?.evidence?.length === 0}
                                    errors={errors}
                                    onValueChange={handleInput}
                                    value={formObject?.evidenceLink}
                                />
                            </div>
                            <ProofAndPenalties drawType={drawType} penAndFine={penAndFine(editData)} />
                        </>

                    }
                    <SaveCancelButton handleCancel={handleCancel} handleSave={handleSubmit(submitValidation)} />
                </div>

            </SwipeableDrawer>
        </div>
    )
}

ComplianceDrawer.propTypes = {
    wholeData: PropTypes.any,
    surveyValidate: PropTypes.any,
    viewCompById: PropTypes.any,
    setEditState: PropTypes.any,
    editData: PropTypes.any,
    editState: PropTypes.any,
    drawType: PropTypes.any
}
export default ComplianceDrawer
